<template>
  <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app>
    <v-list class="text-xs-center">
      <div style="width:90%;margin:auto">
        <img src="../images/logo-brilhar-site.png" style="width:50%" alt="Vuetify">
      </div>
    </v-list>
    <v-divider />
    <v-list dense>
      <template v-show="items.length>0" v-for="item in items">
        <v-layout v-if="item.heading" :key="item.heading" row align-center>
          <v-flex xs6>
            <v-subheader v-if="item.heading">
              {{ item.heading }}
            </v-subheader>
          </v-flex>
          <v-flex xs6 class="text-xs-center">
            <a href="#!" class="body-2 black--text">EDIT</a>
          </v-flex>
        </v-layout>
        <v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" :prepend-icon="item.icon"
          append-icon="arrow_drop_down">
          <v-list-tile slot="activator">
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.to">
            <v-list-tile-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ child.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile v-else :key="item.text" :to="item.to">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <template v-if="items.length==0">
        <div style="width:80%;margin:auto">
          <h1>Selecine Uma Empresa</h1>
        </div>
      </template>
      <v-divider />
      <template>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>directions_run</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sair</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import DrawerItems from "../data/DrawerItems/Items";
import UserService from '../service/UserService';
  export default {
    created() {
      window.getApp.$on('CLOSE_DRAWER_MENU', () => {
        this.drawer = false;
      });
      window.getApp.$on('OPEN_DRAWER_MENU', () => {
        this.drawer = true;
      });
    },
    beforeMount(){
      
    },
    mounted(){
      if (this.$store.getters.getCompany) {
        this.loadAccess(this.$store.getters.getCompany)
      }
    },
    methods: {
      logout() {
        UserService.removeUserFromLocalStorage()
        this.$router.push("/");
        this.$store.commit("loggoutUser");
        this.$emit("loggout");
  
      },
      loadAccess(company){
        this.items = DrawerItems.getItems(company);
        this.$store.commit('setEntities',company);
      }
    },
    data() {
      return {
        drawer: false,
        items: []
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/DrawerMenu.vue